module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lenora Worth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lenora Worth writes for Love Inspired and Love Inspired Suspense. She is a Carol Award finalist and a "), _c('I', [_vm._v("New York Times")]), _vm._v(", "), _c('I', [_vm._v("USA Today")]), _vm._v(", and "), _c('I', [_vm._v("PW")]), _vm._v(" bestselling author. She writes Southern stories set in places she loves such as Georgia, Texas,  Louisiana, and Florida. Lenora is married and has two grown children and now lives near the ocean in the Panhandle of Florida. She loves reading, shoe shopping, long walks on the beach, mojitoes and road trips.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oKm2S5/tc-custom/9781488090417.jpg?1726617359235",
      "alt": "This image is the cover for the book Their Amish Reunion, Amish Seasons"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Their Amish Reunion, Amish Seasons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Return to Lancaster CountyLove blooms in the Amish Seasons series  Widowed single mother Ava Jane Graber can’t believe her eyes. Her first love is back in Lancaster County. Years ago, Jeremiah did the unthinkable: left the Amish—and her—for the Navy SEALs. Now the prodigal hero wants redemption from his community, his family and from the woman he never forgot. For the ex-soldier, becoming Ava’s husband is his ultimate mission.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0